import { PageLayout } from '@kcftech/design-system';
import styled from 'styled-components';

export const TablePageLayout = styled(PageLayout.Primary)`
    overflow-y: hidden !important;
    display: flex;
    flex-direction: column;
    padding-bottom: 2rem;
    box-sizing: border-box;
`;
